<template>
  <div class="underLease-group-dashboard-riskOrders" v-loading="loading">
    <FiltersBox
      class="mb16"
      :filterList="globalFilter.filterList"
      :model.sync="globalFilter.model"
      @change="handleGlobalFiltersChange"
    />

    <el-radio-group class="mb16" v-model="statCycle" size="small" @input="handleStatCycleChange">
      <el-radio-button :label="1">昨日</el-radio-button>
      <el-radio-button :label="2">本周</el-radio-button>
      <el-radio-button :label="3">本月</el-radio-button>
    </el-radio-group>

    <el-row class="mb16" :gutter="16">
      <el-col :span="24">
        <!-- 司机履约风控 -->
        <HorizontalCardStyle1
          :title="riskWarnOrderData.title"
          :dataDesc="riskWarnOrderData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="riskWarnOrderData.primaryDataList"
          :secondaryDataList="riskWarnOrderData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <!-- 逾期催收总计 -->
    <HorizontalCardStyle1
      class="mb16"
      :title="overdueDebtOrderData.title"
      :dataDesc="overdueDebtOrderData.dataDesc"
      :dataUpdateTime="dataUpdateTime"
      :primaryDataList="overdueDebtOrderData.primaryDataList"
      :secondaryDataList="overdueDebtOrderData.secondaryDataList"
    />

    <!-- 个人客户逾期催收 -->
    <HorizontalCardStyle1
      class="mb16"
      :title="rentOverdueDebtData.title"
      :dataDesc="rentOverdueDebtData.dataDesc"
      :dataUpdateTime="dataUpdateTime"
      :primaryDataList="rentOverdueDebtData.primaryDataList"
      :secondaryDataList="rentOverdueDebtData.secondaryDataList"
    />

    <!-- 企业客户逾期催收 -->
    <HorizontalCardStyle1
      class="mb16"
      :title="entOverdueDebtData.title"
      :dataDesc="entOverdueDebtData.dataDesc"
      :dataUpdateTime="dataUpdateTime"
      :primaryDataList="entOverdueDebtData.primaryDataList"
      :secondaryDataList="entOverdueDebtData.secondaryDataList"
    />

    <div class="module-title">数据分析</div>

    <el-row class="mb16">
      <el-col :span="24">
        <FiltersBox
          :filterList="localFilter.filterList"
          :model.sync="localFilter.model"
          @change="handleLocalFiltersChange"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 司机履约风控（折线图） -->
        <LineChartCard
          class="chart"
          :title="riskWarnOrderChartData.title"
          :tooltip="riskWarnOrderChartData.tooltip"
          :dataDesc="riskWarnOrderChartData.dataDesc"
          :dataUpdateTime="riskWarnOrderChartData.dataUpdateTime"
          :xAxis="riskWarnOrderChartData.xAxis"
          :yAxis="riskWarnOrderChartData.yAxis"
          :legendData="riskWarnOrderChartData.legendData"
          :seriesData="riskWarnOrderChartData.seriesData"
          :unit="riskWarnOrderChartData.unit"
        />
      </el-col>
      <el-col :span="12">
        <!-- 逾期催收（折线图） -->
        <LineChartCard
          class="chart"
          :title="overdueChartData.title"
          :tooltip="overdueChartData.tooltip"
          :dataDesc="overdueChartData.dataDesc"
          :dataUpdateTime="overdueChartData.dataUpdateTime"
          :xAxis="overdueChartData.xAxis"
          :yAxis="overdueChartData.yAxis"
          :legendData="overdueChartData.legendData"
          :seriesData="overdueChartData.seriesData"
          :unit="overdueChartData.unit"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 逾期客户占比 -->
        <PieChartCard
          :title="overdueCustomerChartData.title"
          :tooltip="overdueCustomerChartData.tooltip"
          :dataDesc="overdueCustomerChartData.dataDesc"
          :dataUpdateTime="overdueCustomerChartData.dataUpdateTime"
          :total="overdueCustomerChartData.total"
          :totalTitle="overdueCustomerChartData.totalTitle"
          :seriesData="overdueCustomerChartData.seriesData"
        />
      </el-col>
      <el-col :span="12">
        <!-- 逾期金额客户TOP10 -->
        <RankingListCardStyle2
          :title="overdueTopData.title"
          :tooltip="overdueTopData.tooltip"
          :dataDesc="overdueTopData.dataDesc"
          :dataUpdateTime="overdueTopData.dataUpdateTime"
          :filterList="overdueTopData.filterList"
          :filterModel.sync="overdueTopData.filterModel"
          :btnText="overdueTopData.btnText"
          :tableColumns="overdueTopData.tableColumns"
          :tableData="overdueTopData.tableData"
          @btnClick="handleMoreBtnClick"
          @radioChange="handelCustomerTypeChange"
          authority="under_lease_over_due_sum"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getOverdueCustomer, getOverdueTop, getSensitiveOverdueTop, getRiskOrderChart, getRiskOrderInfo } from '@/api/domain/underLease'
import HorizontalCardStyle1 from '@/bizComponents/Dashboard/cards/horizontalCard/style1.vue'
import LineChartCard from '@/bizComponents/Dashboard/cards/lineChartCard/index.vue'
import PieChartCard from '@/bizComponents/Dashboard/cards/pieChartCard/index.vue'
import RankingListCardStyle2 from '@/bizComponents/Dashboard/cards/rankingListCard/style2.vue'
import FiltersBox from '@/bizComponents/Dashboard/filtersBox/index.vue'
import { thisMonthT_1, thisWeekT_1, yesterday } from '@/bizComponents/Dashboard/utils/date'
import { getYAxisNumMax } from '@/bizComponents/Dashboard/utils/function'
import { convertNumber } from '@/utils/'
import moment from 'moment'

// 客户类型：1——个人；2——企业
const CUSTOMER_TYPE = {
  COMPANY: 2,
  PERSON: 1,
}

// top10逾期API配置
const TOP10_API = {
  [CUSTOMER_TYPE.PERSON]: getSensitiveOverdueTop,
  [CUSTOMER_TYPE.COMPANY]: getOverdueTop,
}

export default {
  components: {
    FiltersBox,
    HorizontalCardStyle1,
    LineChartCard,
    PieChartCard,
    RankingListCardStyle2,
  },
  provide() {
    return {
      ratioConfig: this.globalFilter.model,
    }
  },
  data() {
    return {
      // 全局筛选
      globalFilter: {
        filterList: [
          {
            type: 'DeptSelect',
            label: '所属部门',
            name: 'deptId',
            options: [],
          },
          {
            type: 'select',
            label: '环比/同比',
            name: 'showRatio',
            options: [
              {
                label: '展示',
                value: true,
              },
              {
                label: '不展示',
                value: false,
              },
            ],
          },
        ],
        model: {
          deptId: this.$store.getters.userInfo.deptId || '',
          showRatio: true,
        },
      },
      // 统计周期(1:昨日 2:当周平均 3:当月平均)
      statCycle: 1,
      // 局部筛选
      localFilter: {
        filterList: [
          {
            type: 'dateRange',
            label: '时间',
            name: 'date',
            t_1: true,
            pickerOptions: {
              tipConfig: {
                type: 1,
                daysNum: 180,
              },
              disabledDate: (time) => {
                return time.getTime() >= new Date(moment().format('YYYY-MM-DD 00:00:00')).getTime()
              },
            },
          },
        ],
        model: {
          // 默认最近7天
          date: [
            moment(moment(Date.now() - 24 * 60 * 60 * 1000 - (7 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD HH:mm:ss'),
            moment(moment(Date.now() - 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
          ],
        },
      },
      // 数据更新时间
      dataUpdateTime: '',
      // 司机履约风控
      riskWarnOrderData: {
        title: '司机履约风控',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 逾期催收总计
      overdueDebtOrderData: {
        title: '逾期催收总计',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 个人客户逾期催收
      rentOverdueDebtData: {
        title: '个人客户逾期催收',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 企业客户逾期催收
      entOverdueDebtData: {
        title: '企业客户逾期催收',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 司机履约风控图表
      riskWarnOrderChartData: {
        title: '司机履约风控',
        tooltip: '统计周期内高危、高、中、底4个等级的风控订单数及占比，统计周期为预警的开始时间',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 50),
        },
        legendData: ['高危风险', '高风险', '中风险', '低风险'],
        seriesData: [],
      },
      // 逾期催收图表
      overdueChartData: {
        title: '逾期催收',
        tooltip: '统计周期内重度、中度、轻度3个等级的逾期应收单数及占比，统计周期为“应收日期”',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 50),
        },
        legendData: ['重度逾期', '中度逾期', '轻度逾期'],
        seriesData: [],
      },
      // 逾期客户占比
      overdueCustomerChartData: {
        title: '逾期客户占比',
        tooltip: '统计周期内逾期个人与企业客户数量及占比，统计周期为应收日期',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        totalTitle: '逾期客户总数',
        total: 0,
        seriesData: [],
      },
      // 逾期金额客户TOP10
      overdueTopData: {
        title: '逾期金额客户TOP10',
        tooltip: '统计周期内逾期金额top10的个人与企业客户名称、逾期金额、占比',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        filterList: [
          {
            type: 'radio',
            label: '客户类型',
            name: 'customerType',
            options: [
              {
                label: '个人客户',
                value: CUSTOMER_TYPE.PERSON,
              },
              {
                label: '企业客户',
                value: CUSTOMER_TYPE.COMPANY,
              },
            ],
          },
        ],
        filterModel: {
          customerType: CUSTOMER_TYPE.PERSON,
        },
        btnText: '查看更多',
        tableColumns: [
          {
            name: 'id',
            columnProps: {
              label: '排名',
              prop: 'id',
            },
          },
          {
            name: 'name',
            columnProps: {
              label: '名称',
              prop: 'name',
            },
          },
          {
            name: 'amount',
            columnProps: {
              label: '欠款金额(元)',
              prop: 'amount',
            },
          },
          {
            name: 'rate',
            columnProps: {
              label: '占比',
              prop: 'rate',
            },
          },
        ],
        tableData: [],
      },
      loading: false,
    }
  },
  computed: {
    deptId() {
      return this.$store.getters.userInfo.deptId
    },
    params() {
      const { date } = this.localFilter.model
      const startDate = Array.isArray(date) ? moment(date[0]).format('YYYY-MM-DD') : ''
      const endDate = Array.isArray(date) ? moment(date[1]).format('YYYY-MM-DD') : ''
      return {
        deptIdList: this.globalFilter.model.deptId ? [this.globalFilter.model.deptId] : [],
        customerType: this.overdueTopData.filterModel.customerType,
        statCycle: this.statCycle,
        startDate,
        endDate,
      }
    },
  },
  watch: {
    deptId: {
      handler(val) {
        if (val) {
          this.globalFilter.model.deptId = val || ''
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.update()
  },
  methods: {
    update() {
      this.loading = true
      Promise.all([
        this.getRiskOrderInfo(),
        this.getRiskOrderChart(),
        this.getOverdueCustomer(),
        this.getOverdueTop(),
      ]).finally(() => {
        this.loading = false
      })
    },
    handleGlobalFiltersChange() {
      this.update()
    },
    handleLocalFiltersChange() {
      this.loading = true
      Promise.all([
        this.getRiskOrderChart(),
        this.getOverdueCustomer(),
        this.getOverdueTop(),
      ]).finally(() => {
        this.loading = false
      })
    },
    handleStatCycleChange() {
      this.loading = true
      Promise.all([
        this.getRiskOrderInfo(),
      ]).finally(() => {
        this.loading = false
      })
    },
    handelCustomerTypeChange() {
      this.loading = true
      Promise.all([
        this.getOverdueTop(),
      ]).finally(() => {
        this.loading = false
      })
    },
    // 跳转租赁中-预期催收-逾期汇总表，欠租日期为统计周期
    handleMoreBtnClick() {
      this.toOverdueSummary({
        dateRange: this.exportTime(),
      })
    },
    // 跳转租赁中-逾期催收-逾期汇总表
    toOverdueSummary({ dateRange, customerType, finishState }) {
      const query = {
        search: {},
      }

      // 欠款日期
      if (typeof dateRange !== 'undefined') {
        query.search.dateRange = dateRange
      }
      // 客户来源
      if (typeof customerType !== 'undefined') {
        query.search.customerType = customerType
      }
      // 还款状态
      if (typeof finishState !== 'undefined') {
        query.search.finishState = finishState
      }

      this.$router.push({
        path: '/underLease/overdue/summary',
        query: {
          query: JSON.stringify(query),
        },
      })
    },
    // 跳转租赁中-逾期催收-催收明细表-逾期明细表
    toOverdueDetailList({ tabType, dateRange, overDueLevel, finishState, customerType, followState }) {
      const query = {
        search: {},
      }

      // 应收日期
      if (typeof dateRange !== 'undefined') {
        query.search.dateRange = dateRange
      }
      // 逾期阶段
      if (typeof overDueLevel !== 'undefined') {
        query.search.overDueLevel = overDueLevel
      }
      // 客户来源
      if (typeof customerType !== 'undefined') {
        query.search.customerType = customerType
      }
      // 还款状态
      if (typeof finishState !== 'undefined') {
        query.search.finishState = finishState
      }

      // 跟进状态
      if (typeof followState !== 'undefined') {
        query.search.followState = followState
      }

      this.$router.push({
        path: '/underLease/overdue/detailList',
        query: {
          tabType: tabType || '',
          query: JSON.stringify(query),
        },
      })
    },
    // 获取风控订单信息
    async getRiskOrderInfo() {
      const res = await getRiskOrderInfo(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.dataUpdateTime = data.updateTime || ''
        // 司机履约风控
        this.riskWarnOrderData.primaryDataList = [
          {
            label: '预警中风控总数',
            value: data.riskWarnTotalNum || 0,
            tooltip: '预警状态为“预警中”的风控订单总数',
          },
        ]
        this.riskWarnOrderData.secondaryDataList = [
          {
            label: '新增预警数',
            value: data.riskWarnNum || 0,
            tooltip: '统计周期内新增的预警订单数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.riskWarnNumDayRadio,
                },
                {
                  name: '周同比',
                  value: data.riskWarnNumWeekYoY,
                },
              ]
              : [],
          },
          {
            label: '高危风险占比',
            value: ((data.riskWarnHighRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '预警状态为“预警中”且风险等级为“高危风险”的订单数/预警状态为“预警中”总订单数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.riskWarnHighRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.riskWarnHighRateWeekYoY,
                },
              ]
              : [],
          },
          {
            label: '预警跟进完成率',
            value: ((data.riskWarnFollowRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '预警状态为“预警中”且添加过跟进信息的订单数/预警状态为“预警中”总订单数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.riskWarnFollowRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.riskWarnFollowRateWeekYoY,
                },
              ]
              : [],
          },
        ]
        // 逾期催收总计
        this.overdueDebtOrderData.primaryDataList = [
          {
            label: '欠租总金额',
            value: data.overdueDebtTotalAmount ? convertNumber((data.overdueDebtTotalAmount) / 10000) : 0,
            width: '266px',
            unit: '万元',
            valueTooltip: `${convertNumber(data.overdueDebtTotalAmount || 0)}元`,
            tooltip: '欠租总金额',
            // 跳转租赁中-催收管理-逾期汇总表
            clickCallback: this.judgePermission('under_lease_over_due_sum') && (() => this.toOverdueSummary({})),
          },
        ]
        this.overdueDebtOrderData.secondaryDataList = [
          {
            label: '新增欠租金额',
            value: data.overdueDebtAmount ? convertNumber((data.overdueDebtAmount) / 10000) : 0,
            unit: '万元',
            valueTooltip: `${convertNumber(data.overdueDebtAmount || 0)}元`,
            tooltip: '统计周期内的新增欠租总金额',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.overdueDebtAmountDayRadio,
                },
                {
                  name: '周同比',
                  value: data.overdueDebtAmountWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-催收管理-逾期汇总表，欠租日期为统计周期
            clickCallback: this.judgePermission('under_lease_over_due_sum') && (() => this.toOverdueSummary({
              dateRange: this.exportTime(),
            })),
          },
          {
            label: '重度逾期占比',
            value: ((data.overdueHighRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '统计周期内还款状态为“未结清”且逾期状态为“重度”的应收单数量/统计周期内还款状态为“未结清”的应收单总数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.overdueHighRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.overdueHighRateWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-催收明细表-逾期明细表 应收日期为统计周期、逾期阶段为重度、还款状态为未结清
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              overDueLevel: 3,
              finishState: 0,
              dateRange: this.exportTime(),
            })),
          },
          {
            label: '逾期跟进完成率',
            value: ((data.overdueFollowRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '统计周期内还款状态为“未结清”且跟进状态为“跟进中”的应收单数量/统计周期内还款状态为“未结清”的应收单总数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.overdueFollowRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.overdueFollowRateWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-催收明细表-逾期明细表 应收日期为统计周期、跟进状态为“跟进中”、还款状态为未结清
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              followState: 1,
              finishState: 0,
              dateRange: this.exportTime(),
            })),
          },
          // 占位
          {},
          {},
        ]

        // 个人客户逾期催收
        this.rentOverdueDebtData.primaryDataList = [
          {
            label: '个人客户欠租金额',
            value: data.rentOverdueDebtTotalAmount ? convertNumber((data.rentOverdueDebtTotalAmount) / 10000) : 0,
            width: '266px',
            unit: '万元',
            valueTooltip: `${convertNumber(data.rentOverdueDebtTotalAmount || 0)}元`,
            tooltip: '个人客户欠租金额',
            // 跳转租赁中-催收管理-逾期明细表 客户来源为“个人”
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              customerType: CUSTOMER_TYPE.PERSON,
            })),
          },
        ]
        this.rentOverdueDebtData.secondaryDataList = [
          {
            label: '新增个人欠租金额',
            value: data.rentOverdueDebtAmount ? convertNumber((data.rentOverdueDebtAmount) / 10000) : 0,
            unit: '万元',
            valueTooltip: `${convertNumber(data.rentOverdueDebtAmount || 0)}元`,
            tooltip: '统计周期内个人客户的新增欠租金额',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.rentOverdueDebtAmountDayRadio,
                },
                {
                  name: '周同比',
                  value: data.rentOverdueDebtAmountWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-催收管理-逾期明细表 客户来源为“个人” 欠租日期为统计周期
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              customerType: CUSTOMER_TYPE.PERSON,
              dateRange: this.exportTime(),
            })),
          },
          {
            label: '个人重度逾期占比',
            value: ((data.rentOverdueHighRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '统计周期内个人客户还款状态为“未结清”且逾期状态为“重度”的应收单数量/统计周期内还款状态为“未结清”的应收单总数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.rentOverdueHighRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.rentOverdueHighRateWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-催收管理-逾期明细表 客户来源为“个人”、应收日期为统计周期、逾期阶段为重度、还款状态为未结清
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              customerType: CUSTOMER_TYPE.PERSON,
              overDueLevel: 3,
              finishState: 0,
              dateRange: this.exportTime(),
            })),
          },
          {
            label: '个人逾期跟进完成率',
            value: ((data.rentOverdueFollowRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '统计周期内个人客户还款状态为“未结清”且跟进状态为“跟进中”的应收单数量/统计周期内还款状态为“未结清”的应收单总数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.rentOverdueFollowRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.rentOverdueFollowRateWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-催收管理-逾期明细表 客户来源为“个人”、应收日期为统计周期、跟进状态为“跟进中”、还款状态为未结清
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              customerType: CUSTOMER_TYPE.PERSON,
              followState: 1,
              finishState: 0,
              dateRange: this.exportTime(),
            })),
          },
          // 占位
          {},
          {},
        ]

        // 企业客户逾期催收
        this.entOverdueDebtData.primaryDataList = [
          {
            label: '企业客户欠租金额',
            value: data.entOverdueDebtTotalAmount ? convertNumber((data.entOverdueDebtTotalAmount) / 10000) : 0,
            width: '266px',
            unit: '万元',
            valueTooltip: `${convertNumber(data.entOverdueDebtTotalAmount || 0)}元`,
            tooltip: '企业客户欠租金额',
            // 跳转租赁中-催收管理-逾期明细表 客户来源为“企业”
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              customerType: CUSTOMER_TYPE.COMPANY,
            })),
          },
        ]
        this.entOverdueDebtData.secondaryDataList = [
          {
            label: '新增企业欠租金额',
            value: data.entOverdueDebtAmount ? convertNumber((data.entOverdueDebtAmount) / 10000) : 0,
            unit: '万元',
            valueTooltip: `${convertNumber(data.entOverdueDebtAmount || 0)}元`,
            tooltip: '统计周期内企业客户的新增欠租金额',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.entOverdueDebtAmountDayRadio,
                },
                {
                  name: '周同比',
                  value: data.entOverdueDebtAmountWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-催收管理-逾期明细表 客户来源为“企业” 欠租日期为统计周期
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              customerType: CUSTOMER_TYPE.COMPANY,
              dateRange: this.exportTime(),
            })),
          },
          {
            label: '企业重度逾期占比',
            value: ((data.entOverdueHighRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '统计周期内企业客户还款状态为“未结清”且逾期状态为“重度”的应收单数量/统计周期内还款状态为“未结清”的应收单总数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.entOverdueHighRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.entOverdueHighRateWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-催收管理-逾期明细表 客户来源为“企业”、应收日期为统计周期、逾期阶段为重度、还款状态为未结清
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              customerType: CUSTOMER_TYPE.COMPANY,
              overDueLevel: 3,
              finishState: 0,
              dateRange: this.exportTime(),
            })),
          },
          {
            label: '企业逾期跟进完成率',
            value: ((data.entOverdueFollowRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '统计周期内企业客户还款状态为“未结清”且跟进状态为“跟进中”的应收单数量/统计周期内还款状态为“未结清”的应收单总数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.entOverdueFollowRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.entOverdueFollowRateWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-催收管理-逾期明细表 客户来源为“企业”、应收日期为统计周期、跟进状态为“跟进中”、还款状态为未结清
            clickCallback: this.judgePermission('under_lease_over_due_hasten_debt') && (() => this.toOverdueDetailList({
              tabType: 'overdue',
              customerType: CUSTOMER_TYPE.COMPANY,
              followState: 1,
              finishState: 0,
              dateRange: this.exportTime(),
            })),
          },
          // 占位
          {},
          {},
        ]
      }
    },
    // 获取司机履约风控、逾期催收图表
    async getRiskOrderChart() {
      const res = await getRiskOrderChart(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        // 司机履约风控
        this.riskWarnOrderChartData.dataUpdateTime = data[0]?.updateTime || ''
        this.riskWarnOrderChartData.xAxis.data = data.map((item) => item.ds) || []
        this.riskWarnOrderChartData.seriesData = [
          {
            name: '高危风险',
            data: data.map((item) => ([
              item.ds,
              item.riskWarnVeryHighNum || 0,
              {
                dataTitle: this.riskWarnOrderChartData.title,
                ratioList: [{
                  name: '',
                  value: item.riskWarnVeryHighNumRate,
                  hideChangeTrend: true,
                }],
              },
            ])),
          },
          {
            name: '高风险',
            data: data.map((item) => ([
              item.ds,
              item.riskWarnHighNum || 0,
              {
                dataTitle: this.riskWarnOrderChartData.title,
                ratioList: [{
                  name: '',
                  value: item.riskWarnHighNumRate,
                  hideChangeTrend: true,
                }],
              },
            ])),
          },
          {
            name: '中风险',
            data: data.map((item) => ([
              item.ds,
              item.riskWarnMediumNum || 0,
              {
                dataTitle: this.riskWarnOrderChartData.title,
                ratioList: [{
                  name: '',
                  value: item.riskWarnMediumNumRate,
                  hideChangeTrend: true,
                }],
              },
            ])),
          },
          {
            name: '低风险',
            data: data.map((item) => ([
              item.ds,
              item.riskWarnLowNum || 0,
              {
                dataTitle: this.riskWarnOrderChartData.title,
                ratioList: [{
                  name: '',
                  value: item.riskWarnLowNumRate,
                  hideChangeTrend: true,
                }],
              },
            ])),
          },
        ]

        // 逾期催收
        this.overdueChartData.dataUpdateTime = data[0]?.updateTime || ''
        this.overdueChartData.xAxis.data = data.map((item) => item.ds) || []
        this.overdueChartData.seriesData = [
          {
            name: '重度逾期',
            data: data.map((item) => ([
              item.ds,
              item.overdueHighNum || 0,
              {
                dataTitle: this.overdueChartData.title,
                ratioList: [{
                  name: '',
                  value: item.overdueHighNumRate,
                  hideChangeTrend: true,
                }],
              },
            ])),
          },
          {
            name: '中度逾期',
            data: data.map((item) => ([
              item.ds,
              item.overdueMediumNum || 0,
              {
                dataTitle: this.overdueChartData.title,
                ratioList: [{
                  name: '',
                  value: item.overdueMediumNumRate,
                  hideChangeTrend: true,
                }],
              },
            ])),
          },
          {
            name: '轻度逾期',
            data: data.map((item) => ([
              item.ds,
              item.overdueLowNum || 0,
              {
                dataTitle: this.overdueChartData.title,
                ratioList: [{
                  name: '',
                  value: item.overdueLowNumRate,
                  hideChangeTrend: true,
                }],
              },
            ])),
          },
        ]
      }
    },
    // 逾期客户占比图表
    async getOverdueCustomer() {
      const res = await getOverdueCustomer(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.overdueCustomerChartData.dataUpdateTime = data.updateTime || ''
        this.overdueCustomerChartData.total = data.overdueCustomerTotalNum || 0
        this.overdueCustomerChartData.seriesData = [
          {
            name: '企业客户',
            value: data.entOverdueCustomerNum || 0,
            ratio: data.entOverdueCustomerNumRate || 0,
          },
          {
            name: '个人客户',
            value: data.rentOverdueCustomerNum || 0,
            ratio: data.rentOverdueCustomerNumRate || 0,
          },
        ]
      }
    },
    // 获取逾期金额客户TOP10
    async getOverdueTop() {
      const res = await TOP10_API[this.params.customerType](this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.overdueTopData.dataUpdateTime = data[0]?.updateTime || ''
        this.overdueTopData.tableData = data.map((item, index) => {
          return {
            ...item,
            id: index + 1,
            rate: `${((item.rate || 0) * 100).toFixed(2)}%`,
          }
        })
      }
    },
    // 判断时间
    exportTime() {
      if (this.statCycle === 1) {
        return yesterday
      } else if (this.statCycle === 2) {
        return thisWeekT_1
      } else {
        return thisMonthT_1
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
.module-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
